//Create a page to add, update and delete services
import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { 
  IoIosCloseCircle,
  IoIosTrash
 } from "react-icons/io";
import { FaUserEdit } from "react-icons/fa";
import EditServiceForm from './EditServiceForm';
import { Dialog, Transition, DialogPanel, TransitionChild } from '@headlessui/react'

const EditService = (props) => {
  const token = useSelector((state) => state.auth.token);
  const clickedService = props.serviceDetails;
  //const servicesList = props.servicesList;
  const [servicesList, setServicesList] = useState(props.servicesList);
  const [selectedService, setSelectedService] = useState(clickedService);
  const [showEditServiceFormPopup, setShowEditServiceFormPopup] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const handleCancelClick = () => {
    setShowEditServiceFormPopup(false);
  };

  const handleServiceUpdate = (updatedService) => {
    
    // Update the state here, e.g., adding the updated service to the services list
    //setServicesList(prevServices => [...prevServices, updatedService]);

    setSelectedService(updatedService);
    props.setServicesList(servicesList.map(service => service.id === updatedService.id ? updatedService : service));
    // If navigation is needed, trigger it here or pass down the necessary props/callbacks to the child
  };

  const handleDeleteService = (serviceId) => {
    // Delete the service from the services list
    props.setServicesList(servicesList.filter(service => service.id !== serviceId));
    //props.setShowEditService(false);
    fetch(`${process.env.REACT_APP_SERVICE_API_URL}/delete-service/${serviceId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Api-Name': 'service-api',
      }
    })
      .then(response => response.json())
      .then(data => {
        props.setServicesList(servicesList.filter(service => service.id !== serviceId));
        props.setShowEditService(false);
      })
      .catch(error => console.error(error));
  }

  return (
    <>
      <div className="text-pri-white w-screen">
        <button className="absolute right-0 p-4" onClick={() => props.setShowEditService(false)}>
          <IoIosCloseCircle className="size-8 md:size-12 text-pri-yellow hover:rotate-90 transform duration-300 hover:size-12"/>
        </button>
        <button
          className=" text-pri-white px-4 py-2 mt-4 "
          onClick={() => setShowEditServiceFormPopup(true)}
        >
          <FaUserEdit className="size-5 md:size-8 text-pri-yellow rounded-full absolute top-32 right-0 mr-5 mt-5 hover:size-12"/>
        </button>
        <button className="text-pri-white px-4 py-2 mt-4" onClick={() => setShowDeleteConfirmation(true)}>
          <IoIosTrash className="size-5 md:size-8 text-pri-yellow rounded-full absolute top-48 right-0 mr-5 mt-5 hover:size-12"/>
        </button>
        <div className="flex flex-col">
          <div className="p-8 flex gap-10 ml-10"> 
            <img className="h-48 w-48 flex-shrink-0 rounded-full mt-0" src={selectedService.image_url} alt="" />
            <div className="container h-48 w-3/4 bg-sec-dark p-4 rounded-3xl flex flex-col items-start relative overflow-x-auto"> 

              <h1 className="text-3xl text-pri-white">{selectedService.name}</h1>
              <span className="inline-flex flex-shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-pri-dark-shadow ring-1 ring-inset ring-pri-dark-shadow">
                {selectedService.status}
              </span>
              <p className="text-pri-white max-w-3xl text-wrap mt-4">{selectedService.description}</p>

            </div>          
          </div>
          <div className="container bg-sec-dark ml-20 p-4 rounded-3xl flex content-start relative"> 
            <h1 className="text-2xl text-pri-white mt-3">Tags :</h1>
            {selectedService.tags.map((tag, index) => (
              <div key={index} className="bg-pri-dark m-2 p-2 rounded-lg">
                <p className="text-pri-white">{tag}</p>
              </div>
            ))}
          </div> 
          <div className="container bg-sec-dark ml-20 p-4 rounded-3xl flex content-start relative mt-6 gap-4"> 
            <h1 className="text-2xl text-pri-white">Price :</h1>
            <p className="text-pri-white text-xl mt-1">£ {selectedService.price}</p>
          </div>
        </div>
      </div>
      {showEditServiceFormPopup ?
      <Transition show={true}>
        <Dialog className="relative z-10" onClose={handleCancelClick}>
          <div className="fixed inset-0 z-10">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white px-8 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl sm:p-6">
                  <div className="bg-dark-modal p-8 rounded-3xl w-full">
                    <EditServiceForm 
                      selectedService={selectedService} 
                      servicesList={servicesList} 
                      setShowEditServiceFormPopup={setShowEditServiceFormPopup}
                      onServiceUpdate={handleServiceUpdate}
                    />
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
      : null }

      {showDeleteConfirmation ?
        <Transition show={true}>
        <Dialog className="relative z-10" onClose={handleCancelClick}>
          <div className="fixed inset-0 z-10">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white px-8 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl sm:p-6">
                  <div className="bg-dark-modal p-8 rounded-3xl w-full">
                    <h1 className="text-pri-dark text-2xl">Are you sure you want to delete this service?</h1>
                    <button className="bg-pri-red text-pri-white p-2 rounded-lg" onClick={() => handleDeleteService(selectedService.id)}>Yes</button>
                    <button className="bg-pri-yellow text-pri-white p-2 rounded-lg" onClick={() => setShowDeleteConfirmation(false)}>No</button>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
      : null
      }
    </>
  );
}

export default EditService;